import { useEffect, useState } from "react";

const SECTIONS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "rooms", label: "Rooms" },
  { id: "restaurant-bar", label: "Dine" },
  { id: "nearby", label: "Nearby" },
  { id: "facilities", label: "Facilities" },
  { id: "gallery", label: "Gallery" },
  { id: "offers", label: "Offers" },
  { id: "reviews", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export default function SideDots() {
  const [active, setActive] = useState("home");

  useEffect(() => {
    const handler = () => {
      let current = "home";
      for (const s of SECTIONS) {
        const el = document.getElementById(s.id);
        if (!el) continue;
        const rect = el.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.45) current = s.id;
      }
      setActive(current);
    };
    handler();
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <nav
      aria-label="Section navigation"
      data-testid="side-dots"
      className="hidden xl:flex flex-col gap-3 fixed right-6 top-1/2 -translate-y-1/2 z-30"
    >
      {SECTIONS.map((s) => (
        <a
          key={s.id}
          href={`#${s.id}`}
          className="group flex items-center gap-3 justify-end"
          aria-label={s.label}
        >
          <span
            className={`text-[10px] tracking-[0.22em] uppercase transition-all duration-300 ${
              active === s.id
                ? "opacity-100 text-[#1A362D]"
                : "opacity-0 group-hover:opacity-100 text-[#5C4033]"
            }`}
          >
            {s.label}
          </span>
          <span
            className={`block rounded-full transition-all duration-300 ${
              active === s.id
                ? "w-2.5 h-2.5 bg-[#C5A059]"
                : "w-1.5 h-1.5 bg-[#5C4033]/30 group-hover:bg-[#C5A059]"
            }`}
          />
        </a>
      ))}
    </nav>
  );
}
